import { Typography } from "@mui/material";
import React from "react";
import { MuiDataGridFontSize } from "../../../theme/App.theme";

const NoRecordsToDisplay = () => {
  return (
    <div className="d-flex align-items-center justify-content-center my-4">
      <Typography
        className="inter-regular-400"
        style={{ fontSize: MuiDataGridFontSize }}
      >
        There are no records to display
      </Typography>
    </div>
  );
};

export default NoRecordsToDisplay;
